import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { UserListAction } from '../userList.action';

type IDependencies = IClientApiDependencySegment;

export const removeClientUser: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(UserListAction.removeClient.started),
  mergeMap((params) => {
    return dependencies.api.deleteUser(params).pipe(
      mergeMap(() => {
        return [
          UserListAction.removeClient.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          UserListAction.removeClient.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
